import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const StyledAside = styled.aside`
  width: 100%;
  float: left;
  position: relative;
  > ul {
    position: relative;
    padding: 0;
    li {
      border-radius: 5px;
      box-shadow: 0 2px 4px 0 rgba(51, 51, 51, .15);
      display: block;
      overflow: hidden;
      margin-bottom: 4px;
      position: relative;
    }
  }

  @media (min-width: 1024px) {
    float: right;
    max-width: 300px;
    height: ${props => props.scrolled ? "76vh" : "64vh"};
    overflow: visible;
    > div:first-child  {
      width: calc(100% - 24px);
      left: 4px;
    }
    > ul {
      height: 100%;
      padding: 20px 14px 20px 4px;
      overflow-x: hidden;
      overflow-y: auto;
      z-index: 1;
      &::-webkit-scrollbar {
        width: 6px;
      }
      &::-webkit-scrollbar-track {
        background-color: #EEE;
      }
      &::-webkit-scrollbar-thumb {
        background-color: #21A0D2;
        border: 2px solid #EEE;
      }
    }
    &::before,
    &::after {
      content: " ";
      position: absolute;
      pointer-events: none;
      width: 100%;
      height: 60px;
      bottom: -40px;
      left: 0;
      z-index: 2;
      background: linear-gradient(to bottom, rgba(242, 242, 242, 0), #F2F2F2 30%);
    }
    &::before {
      top: -20px;
      background: linear-gradient(to top, rgba(242, 242, 242, 0), #F2F2F2 30%);
    }
  }
`;

export default function Aside (props) {
  const {children, scrolled} = props;
  return (
    <StyledAside scrolled={scrolled}>
      {children}
    </StyledAside>
  )
}

Aside.propTypes = {
  children: PropTypes.any,
};
